"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineChapters = void 0;
var player_base_1 = require("@24i/player-base");
var TimelineChapters = (function () {
    function TimelineChapters(player) {
        this.sourceTimeline = [];
        this.player = player;
    }
    Object.defineProperty(TimelineChapters.prototype, "timeline", {
        get: function () {
            var _this = this;
            return this.sourceTimeline.map(function (event) {
                return {
                    type: event.type,
                    name: event.name,
                    start: _this.player.getStreamTime(event.start, event.seekType),
                    end: _this.player.getStreamTime(event.end, event.seekType),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    TimelineChapters.prototype.extractTimelineEvents = function (source, sourceMetadata) {
        var _a, _b, _c, _d;
        var timeline = (_d = (_c = (_a = sourceMetadata === null || sourceMetadata === void 0 ? void 0 : sourceMetadata.timeline) !== null && _a !== void 0 ? _a : (_b = source === null || source === void 0 ? void 0 : source.metadata) === null || _b === void 0 ? void 0 : _b.timeline) !== null && _c !== void 0 ? _c : source === null || source === void 0 ? void 0 : source.timeline) !== null && _d !== void 0 ? _d : [];
        if (timeline.length === 0)
            return [];
        return timeline.filter(function (event) { return event.type !== player_base_1.ISourceTimelineEventType.ADVERTISEMENT; });
    };
    TimelineChapters.prototype.canLoad = function (source, metadata) {
        return this.extractTimelineEvents(source, metadata).length > 0;
    };
    TimelineChapters.prototype.load = function (source, metadata) {
        this.source = source;
        this.updateTimeline(source, metadata);
        return Promise.resolve();
    };
    TimelineChapters.prototype.unload = function () {
        this.source = null;
        this.sourceTimeline = [];
    };
    TimelineChapters.prototype.setMetadata = function (sourceMetadata) {
        this.updateTimeline(this.source, sourceMetadata);
    };
    TimelineChapters.prototype.updateTimeline = function (source, sourceMetadata) {
        this.sourceTimeline = this.extractTimelineEvents(source, sourceMetadata);
    };
    return TimelineChapters;
}());
exports.TimelineChapters = TimelineChapters;
//# sourceMappingURL=index.js.map